import { Injectable } from '@angular/core';
import {LaunchDarklyService} from 'remarketing-angular-library';

@Injectable({
  providedIn: 'root'
})
export class AuctionSummaryConfigurationService {

  constructor(private readonly _launchDarklyService: LaunchDarklyService) { }

  get isBuyerArbitrationEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('arbitrationEnabled', false);
  }

  get isSellerArbitrationEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('sellerArbitrationEnabled', false);
  }

  get isTransportationOrderEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('transportationOrderEnabled', false);
  }
}
